import React, { useEffect, useState } from "react";
import { Descriptions } from "antd";
import dayjs from "dayjs";
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var VaccinView = function VaccinView(_ref) {
  var vaccin_process = _ref.vaccin_process;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      children: [vaccin_process && vaccin_process.first_dose_penta != null && /*#__PURE__*/_jsxs(Descriptions, {
        bordered: true,
        size: "medium",
        title: /*#__PURE__*/_jsx("b", {
          children: "HEPATITE B"
        }),
        column: 4,
        children: [/*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Unit\xE9"
          }),
          children: vaccin_process.unit_penta
        }), vaccin_process.first_dose_penta && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "1\xE8re dose"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.first_dose_penta,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_first_penta && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 1"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_first_penta,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_second_penta && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 2"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_second_penta,
            format: "DD/MM/YYYY"
          })
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Observation"
          }),
          children: vaccin_process.comment_penta
        })]
      }), vaccin_process && vaccin_process.first_dose_coq != null && /*#__PURE__*/_jsxs(Descriptions, {
        bordered: true,
        size: "medium",
        title: /*#__PURE__*/_jsx("b", {
          children: "COQUELLUCHE"
        }),
        column: 4,
        children: [/*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Unit\xE9"
          }),
          children: vaccin_process.unit_coq
        }), vaccin_process.first_dose_coq && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "1\xE8re dose"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.first_dose_coq,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_first_coq && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 1"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_first_coq,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_second_coq && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 2"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_second_coq,
            format: "DD/MM/YYYY"
          })
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Observation"
          }),
          children: vaccin_process.comment_coq
        })]
      }), vaccin_process && vaccin_process.first_dose_teta != null && /*#__PURE__*/_jsxs(Descriptions, {
        bordered: true,
        size: "medium",
        title: /*#__PURE__*/_jsx("b", {
          children: "TETANOS "
        }),
        column: 4,
        children: [/*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Unit\xE9"
          }),
          children: vaccin_process.unit_teta
        }), vaccin_process.first_dose_teta && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "1\xE8re dose"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.first_dose_teta,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_first_teta && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 1"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_first_teta,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_second_teta && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 2"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_second_teta,
            format: "DD/MM/YYYY"
          })
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Observation"
          }),
          children: vaccin_process.comment_teta
        })]
      }), vaccin_process && vaccin_process.first_dose_diph != null && /*#__PURE__*/_jsxs(Descriptions, {
        bordered: true,
        size: "medium",
        title: /*#__PURE__*/_jsx("b", {
          children: "DIPHTHERIE"
        }),
        column: 4,
        children: [/*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Unit\xE9"
          }),
          children: vaccin_process.unit_diph
        }), vaccin_process.first_dose_diph && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "1\xE8re dose"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.first_dose_diph,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_first_diph && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 1"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_first_diph,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_second_diph && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 2"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_second_diph,
            format: "DD/MM/YYYY"
          })
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Observation"
          }),
          children: vaccin_process.comment_diph
        })]
      }), vaccin_process && vaccin_process.first_dose_influ != null && /*#__PURE__*/_jsxs(Descriptions, {
        bordered: true,
        size: "medium",
        title: /*#__PURE__*/_jsx("b", {
          children: "INFLUENZAE"
        }),
        column: 4,
        children: [/*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Unit\xE9"
          }),
          children: vaccin_process.unit_influ
        }), vaccin_process.first_dose_influ && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "1\xE8re dose"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.first_dose_influ,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_first_influ && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 1"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_first_influ,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_second_influ && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 2"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_second_influ,
            format: "DD/MM/YYYY"
          })
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Observation"
          }),
          children: vaccin_process.comment_influ
        })]
      }), vaccin_process && vaccin_process.first_dose_typhoid != null && /*#__PURE__*/_jsxs(Descriptions, {
        bordered: true,
        size: "medium",
        title: /*#__PURE__*/_jsx("b", {
          children: "F. TYPHOIDE"
        }),
        column: 4,
        children: [/*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Unit\xE9"
          }),
          children: vaccin_process.unit_typhoid
        }), vaccin_process.first_dose_typhoid && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "1\xE8re dose"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.first_dose_typhoid,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_first_typhoid && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 1"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_first_typhoid,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_second_typhoid && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 2"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_second_typhoid,
            format: "DD/MM/YYYY"
          })
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Observation"
          }),
          children: vaccin_process.comment_typhoid
        })]
      }), vaccin_process && vaccin_process.first_dose_meningite != null && /*#__PURE__*/_jsxs(Descriptions, {
        bordered: true,
        size: "medium",
        title: /*#__PURE__*/_jsx("b", {
          children: "MENINGITE"
        }),
        column: 4,
        children: [/*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Unit\xE9"
          }),
          children: vaccin_process.unit_meningite
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "1\xE8re dose"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.first_dose_meningite,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_first_meningite && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 1"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_first_meningite,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_second_meningite && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 2"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_second_meningite,
            format: "DD/MM/YYYY"
          })
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Observation"
          }),
          children: vaccin_process.comment_meningite
        })]
      }), vaccin_process && vaccin_process.first_dose_yf != null && /*#__PURE__*/_jsxs(Descriptions, {
        bordered: true,
        size: "medium",
        title: /*#__PURE__*/_jsx("b", {
          children: "F. JAUNE"
        }),
        column: 4,
        children: [/*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Unit\xE9"
          }),
          children: vaccin_process.unit_yf
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "1\xE8re dose"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.first_dose_yf,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_first_yf && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 1"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_first_yf,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_second_yf && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 2"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_second_yf,
            format: "DD/MM/YYYY"
          })
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Observation"
          }),
          children: vaccin_process.comment_yf
        })]
      }), vaccin_process && vaccin_process.first_dose_bvac != null && /*#__PURE__*/_jsxs(Descriptions, {
        bordered: true,
        size: "medium",
        title: /*#__PURE__*/_jsx("b", {
          children: "BVAC"
        }),
        column: 4,
        children: [/*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Unit\xE9"
          }),
          children: vaccin_process.unit_bvac
        }), vaccin_process.first_dose_bvac && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "1\xE8re dose"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.first_dose_bvac,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_first_bvac && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 1"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_first_bvac,
            format: "DD/MM/YYYY"
          })
        }), vaccin_process.recall_second_bvac && /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Rappel 2"
          }),
          children: /*#__PURE__*/_jsx(Moment, {
            date: vaccin_process.recall_second_bvac,
            format: "DD/MM/YYYY"
          })
        }), /*#__PURE__*/_jsx(Descriptions.items, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Observation"
          }),
          children: vaccin_process.comment_bvac
        })]
      })]
    })
  });
};
export default VaccinView;